// Monarch syntax highlighting for the while-star language.
export default {
    keywords: [
        'and','code:','else','extern','fail','false','if','int','invariant','not','or','post:','pre:','print','swap','true','vars:','while'
    ],
    operators: [
        '%','&','*','+',',','-','..','/',':=',';','<','<=','<=>','=','=>','>','>='
    ],
    symbols: /%|&|\(|\)|\*|\+|,|-|\.\.|\/|:=|;|<|<=|<=>|=|=>|>|>=|\[|\]|\{|\}/,

    tokenizer: {
        initial: [
            { regex: /[_a-zA-Z][\w_]*/, action: { cases: { '@keywords': {"token":"keyword"}, '@default': {"token":"ID"} }} },
            { regex: /[0-9]+/, action: {"token":"number"} },
            { regex: /\"[^\"\n\r]*\"/, action: {"token":"string"} },
            { include: '@whitespace' },
            { regex: /@symbols/, action: { cases: { '@operators': {"token":"operator"}, '@default': {"token":""} }} },
        ],
        whitespace: [
            { regex: /\s+/, action: {"token":"white"} },
        ],
        comment: [
        ],
    }
};
